import { createAction, props } from '@ngrx/store';

export const actionSettingsChangeTheme = createAction('[Settings] Change Theme', props<{ theme: string }>());
